import { FC, PropsWithChildren } from 'react';
import { ProjectThemeContext } from './project-theme-context';
import { useProjectTheme } from './use-project-theme';
import { useParams } from 'react-router-dom';

interface PropTypes {

}

export const ProjectTheme: FC<PropsWithChildren<PropTypes>> = ({ children }) => {

    const { projectId } = useParams<{ projectId: string }>();

    const projectThemeData = useProjectTheme(projectId);

    return <ProjectThemeContext.Provider value={projectThemeData}>
        {children}
    </ProjectThemeContext.Provider>;
};
